<template>
    <div class="biz-account-mgt-filter" :class="{ open: openState}">
        <div class="biz-account-mgt-filter-wrap" v-bind:style="{'min-height': myHeight}">
            <div class="filter-title">
                <img src="@/assets/img/icon/filter_gray.svg" alt="">
                篩選
                <span v-show="filterState" class="clear-filter" @click="setFilterDefault">
                    清除篩選
                </span>
            </div>
            
            <div class="result">
                <div class="view-result" @click="filterClose">
                    查看搜尋結果  {{filterResultTotal}}
                </div>
            </div>
        </div>
        <span class="close" @click="filterClose">
            <img src="@/assets/img/icon/cross_white.svg" alt="">
        </span>
    </div>
</template>
<script>
import VueSlider from 'vue-slider-component'
import '@/assets/css/rent.css'
import RentSelect from '@/components/bussiness/widges/tools/RentSelect.vue';
import VueRangeSlider from 'vue-range-component'
import DatePicker from 'vue2-datepicker';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            openState: this.isOpen,
            myHeight: (window.innerHeight) + 'px',
            filterTop: null,
            filterState: 0,
            filterResultTotal: 0,
        }
    },
    created () {
        
    },
    mounted () {
        
    },
    destroyed () {

    },
    props: {
        isOpen: Boolean,
    },
    watch: {
        isOpen (val) {
            this.openState = val
        },
        accountMgtFilter: {
            handler: function () {
                this.$emit('changeFilter', this.accountMgtFilter)
                this.filterState = 1
            },
            deep: true
        },
    },
    methods: {
        handleScroll: function () {
            let scrollTop = event.target.documentElement.scrollTop
            this.filterTop = (scrollTop-163) + 'px'
        },
        filterClose: function () {
            this.$emit('filterClose', false);
        },
        setFilterDefault: function () {
            // TODO
        },
    },
    computed: {
        ...mapGetters({
        })
    },
    components: {
        RentSelect,
        VueSlider,
        DatePicker,
    }
}
</script>
<style lang="scss" scoped>
    .biz-account-mgt-filter{
        position: fixed;
        width: 279px;
        box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
        background-color: #ffffff;
        // height: 100%;
        top: 0px;
        right: -350px;
        transition: all 1s ease-in-out;
        z-index: 10;
        .biz-account-mgt-filter-wrap{
            position: relative;
            height: 100%;
            .default{
                padding: 20px;
                border-bottom: 1px solid #f0f0f0;
                .title{
                    margin-bottom: 16px;
                }
            }
            .filter-title{
                display: flex;
                align-items: center;
                padding: 24px;
                color: #a8a5a4;
                border-bottom: 1px solid #f0f0f0;
                img{
                    margin-right: 8px;
                }
                .clear-filter{
                    position: absolute;
                    cursor: pointer;
                    font-size: 12px;
                    color: #ff9275;
                    top: 30px;
                    right: 34px;
                }
            }
            .location{
                .group{
                    display: flex;
                    .biz-rent-select:nth-child(1){
                        margin-right: 10px;
                    }
                    .biz-rent-select{
                        width: 75px;
                        height: 18px;
                    }
                }
            }
            .period,
            .rent-date{
                .mx-datepicker {
                    width: 230px;
                    .mx-input-wrapper{
                        .mx-input{
                            height: 46px;
                            border-radius: 4px;
                            border: solid 1px #e0dfde;
                            color: #a8a5a4;
                            padding: 13px 16px;
                            box-shadow: none;
                        }
                        .mx-icon-calendar,
                        .mx-icon-clear{
                            right: 18px;
                        }
                    }
                }
                .mx-datepicker.active{
                    input{
                        border: 1px solid #676362 !important;
                        color: #676362 !important;
                    }
                    i{
                        color: #676362;
                    }
                }
                .mx-datepicker:hover{
                    .mx-input-wrapper{
                        .mx-input{
                            border: 1px solid #676362 !important;
                            color: #676362 !important;
                        }
                    }
                }
            }
            .deposit,
            .rent{
                padding-bottom: 40px;
            }
            .result{
                position: absolute;
                width: 100%;
                height: 76px;
                bottom: 0px;
                display: flex;
                align-items: center;
                justify-content: center;
                box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                .view-result{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #ffffff;
                    font-weight: 500;
                    width: 231px;
                    height: 44px;
                    border-radius: 4px;
                    background-color: #ff9275;
                    cursor: pointer;
                }
            }
        }
        .close{
            position: absolute;
            width: 30px;
            height: 44px;
            background-color: #ff9275;
            border-radius: 10px 0 0 10px;
            left: -30px;
            top: 50%;
            transform: translateY(-50%);
            display: flex;
            align-items: center;
            justify-content: center;
            img{
                cursor: pointer;
            }
        }
    }
    .biz-account-mgt-filter.open{
        right: 0px;
    }
    // @media screen and (max-width: 1280px) {
    //     .biz-account-mgt-filter.open{
    //         right: 24px;
    //     }
    // }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/internalAuth/accountMgt/accountMgtFilter.vue